import Vue from 'vue'
import Router from 'vue-router'


Vue.use(Router)

let router = new Router({
  routes: [{
      path: '/',
      name: 'index',
      component: resolve => {
        require(['@/components/'], resolve)
      }
    },


    {
      path: '/set/info',
      name: '系统设置',
      component: resolve => {
        require(['@/components/set/info'], resolve)
      }
    },
    {
      path: '/template/index',
      name: '模板设置',
      component: resolve => {
        require(['@/components/template/index'], resolve)
      }
    },
    {
      path: '/template/html',
      name: 'HTML管理',
      component: resolve => {
        require(['@/components/template/html'], resolve)
      }
    },
    {
      path: '/material',
      name: '素材管理',
      component: resolve => {
        require(['@/components/material'], resolve)
      }
    },
    {
      path: '/material/list',
      name: '素材库',
      component: resolve => {
        require(['@/components/material/list'], resolve)
      }
    },
    {
      path: '/menu/list',
      name: '菜单管理',
      component: resolve => {
        require(['@/components/menu/list'], resolve)
      }
    },
    {
      path: '/material/category',
      name: '素材分类',
      component: resolve => {
        require(['@/components/material/category'], resolve)
      }
    },
    {
      path: '/tianmu/tongzhi',
      name: '通知管理',
      component: resolve => {
        require(['@/components/tianmu/tongzhi'], resolve)
      }
    },
    {
      path: '/pet/offerings/category',
      name: '宠物供品分类',
      component: resolve => {
        require(['@/components/pet/category'], resolve)
      }
    },
    {
      path: '/pet/offeringsCategory',
      name: '宠物供品分类入口',
      component: resolve => {
        require(['@/components/pet/category'], resolve)
      }
    },
    {
      path: '/pet/offerings/list',
      name: '宠物供品',
      component: resolve => {
        require(['@/components/pet/offerings'], resolve)
      }
    },
    {
      path: '/pet/offerings',
      name: '宠物供品管理',
      component: resolve => {
        require(['@/components/pet/offerings'], resolve)
      }
    },
    {
      path: '/pet/offeringsTaocan',
      name: '供品套餐',
      component: resolve => {
        require(['@/components/pet/taocan'], resolve)
      }
    },
    {
      path: '/pet/offeringsRecord',
      name: '供品记录',
      component: resolve => {
        require(['@/components/pet/offeringsRecord'], resolve)
      }
    },
    {
      path: '/pet/tombstone',
      name: '宠物墓碑模板',
      component: resolve => {
        require(['@/components/pet/tombstone'], resolve)
      }
    },
    {
      path: '/pet/tombstoneList',
      name: '宠物墓碑管理',
      component: resolve => {
        require(['@/components/pet/tombstone'], resolve)
      }
    },
    {
      path: '/mu/list',
      name: '纪念馆',
      component: resolve => {
        require(['@/components/mu/list'], resolve)
      }
    },
    {
      path: '/mu/report',
      name: '举报管理',
      component: resolve => {
        require(['@/components/mu/report'], resolve)
      }
    },
    {
      path: '/tianmu/banner',
      name: 'banner',
      component: resolve => {
        require(['@/components/tianmu/banner'], resolve)
      }
    },
    {
      path: '/article/category',
      name: '文章分类',
      component: resolve => {
        require(['@/components/article/category'], resolve)
      }
    },
    {
      path: '/article/list',
      name: '文章管理',
      component: resolve => {
        require(['@/components/article/list'], resolve)
      }
    },
    {
      path: '/user/login',
      name: '后台登录',
      component: resolve => {
        require(['@/components/user/login'], resolve)
      }
    },
    {
      path: '/aside/list',
      name: '菜单列表',
      component: resolve => {
        require(['@/components/aside/list'], resolve)
      }
    },
    {
      path: '/permission/list',
      name: '权限管理',
      component: resolve => {
        require(['@/components/permission/list'], resolve)
      }
    },
    {
      path: '/permission/group',
      name: '权限分组',
      component: resolve => {
        require(['@/components/permission/group'], resolve)
      }
    },
    {
      path: '/aside/assign',
      name: '菜单权限分配',
      component: resolve => {
        require(['@/components/aside/assign'], resolve)
      }
    },
    {
      path: '/role/list',
      name: '角色管理',
      component: resolve => {
        require(['@/components/role/list'], resolve)
      }
    },
    {
      path: '/role/assign',
      name: '角色权限分配',
      component: resolve => {
        require(['@/components/role/assign'], resolve)
      }
    },

    {
      path: '/user/list',
      name: '用户管理',
      component: resolve => {
        require(['@/components/user/list'], resolve)
      }
    },
    {
      path: '/user/blackList',
      name: '黑名单',
      component: resolve => {
        require(['@/components/user/blackList'], resolve)
      }
    },

    {
      path: '/center/changePassword',
      name: '修改密码',
      component: resolve => {
        require(['@/components/center/changePassword'], resolve)
      }
    },
    {
      path: '/feedback/list',
      name: '反馈管理',
      component: resolve => {
        require(['@/components/feedback/list'], resolve)
      }
    },
    {
      path: '/pet/report',
      name: '宠物举报',
      component: resolve => {
        require(['@/components/pet/report'], resolve)
      }
    },
    {
      path: '/pet/memorial',
      name: '宠物纪念馆',
      component: resolve => {
        require(['@/components/pet/memorial'], resolve)
      }
    },
    {
      path: '/pet/worship',
      name: '宠物祭拜记录',
      component: resolve => {
        require(['@/components/pet/worship'], resolve)
      }
    },
    {
      path: '/tutorial/list',
      name: '教程管理',
      component: resolve => {
        require(['../components/tutorial/list.vue'], resolve)
      }
    },
    {
      path: '/jiapu/list',
      name: '家谱管理',
      component: resolve => {
        require(['@/components/jiapu/list'], resolve)
      }
    },
    {
      path: '/jiapu/members',
      name: '家谱成员',
      component: resolve => {
        require(['@/components/jiapu/members'], resolve)
      }
    },
    {
      path: '/mu/bgList',
      name: '纪念馆背景',
      component: resolve => {
        require(['@/components/mu/bgList'], resolve)
      }
    },
    {
      path: '/mu/bgBindMb',
      name: '背景绑定墓碑',
      component: resolve => {
        require(['@/components/mu/bgBindMb.vue'], resolve)
      }
    },
    {
      path: '/mu/music',
      name: '音乐管理',
      component: resolve => {
        require(['@/components/mu/music'], resolve)
      }
    },
    {
      path: '/mu/jipin',
      name: '纪念馆供品管理',
      component: resolve => {
        require(['@/components/mu/jipin'], resolve)
      }
    },
    {
      path: '/mu/category',
      name: '纪念馆供品分类',
      component: resolve => {
        require(['@/components/mu/category'], resolve)
      }
    },
    {
      path: '/mu/mbList',
      name: '纪念馆墓碑管理',
      component: resolve => {
        require(['@/components/mu/mbList'], resolve)
      }
    },
    {
      path: '/mu/taocan',
      name: '套餐管理',
      component: resolve => {
        require(['@/components/mu/taocan'], resolve)
      }
    },
    {
      path: '/material/banner',
      name: '轮播图管理',
      component: resolve => {
        require(['@/components/material/banner'], resolve)
      }
    },

    {
      path: '/stats/overview',
      name: '数据总览',
      component: resolve => {
        require(['@/components/stats/overview'], resolve)
      }
    },
    {
      path: '/stats/monthlyActive',
      name: '月活用户',
      component: resolve => {
        require(['@/components/stats/monthlyActive'], resolve)
      }
    },
    {
      path: '/stats/muNew',
      name: '新增纪念馆',
      component: resolve => {
        require(['@/components/stats/muNew'], resolve)
      }
    },
    {
      path: '/stats/userNew',
      name: '新增用户',
      component: resolve => {
        require(['@/components/stats/userNew'], resolve)
      }
    },
    {
      path: '/stats/consume',
      name: '购买记录',
      component: resolve => {
        require(['@/components/stats/consume'], resolve)
      }
    },
    {
      path: '/stats/worshipRecord',
      name: '祭拜记录',
      component: resolve => {
        require(['@/components/stats/worshipRecord'], resolve)
      }
    },
    {
      path: '/stats/commentList',
      name: '留言管理',
      component: resolve => {
        require(['@/components/stats/commentList'], resolve)
      }
    },
    {
      path: '/stats/aiMsg',
      name: 'AI消息',
      component: resolve => {
        require(['@/components/stats/aiMsg'], resolve)
      }
    },
    {
      path: '/stats/muAiList',
      name: '违规审核',
      component: resolve => {
        require(['@/components/stats/muAiList'], resolve)
      }
    },



  ]
})

function buildRouteKey(path) {
  let value = String(path || '').replace(/^\//, '').replace(/\//g, '.')
  if (!value) {
    value = 'root'
  }
  return 'route.' + value
}

function injectI18nKey(routes) {
  for (let i = 0; i < routes.length; i++) {
    let route = routes[i]
    if (!route.meta) {
      route.meta = {}
    }
    if (!route.meta.i18nKey) {
      route.meta.i18nKey = buildRouteKey(route.path)
    }
    if (route.children && route.children.length > 0) {
      injectI18nKey(route.children)
    }
  }
}

injectI18nKey(router.options.routes || [])

export default router



// WEBPACK FOOTER //
// ./src/router/index.js